import { l } from '@manychat/manyui'
import { MakeTranslateReturnValue } from '@manychat/manyui/src/utils/localization/format'

import { ConfirmSource } from 'apps/aiAutomation/store/layout/types'

interface ConfirmCopies {
  title: MakeTranslateReturnValue
  description: MakeTranslateReturnValue
  confirmButton: MakeTranslateReturnValue
  cancelButton: MakeTranslateReturnValue
}

export const copiesBySource: Record<ConfirmSource | 'default', ConfirmCopies> = {
  default: {
    title: l.makeTranslate('Your changes won’t be saved'),
    description: l.makeTranslate(
      'You’ve made changes that haven’t been saved. If you leave now, you’ll lose them.',
    ),
    confirmButton: l.makeTranslate('Leave anyway'),
    cancelButton: l.makeTranslate('Keep Editing'),
  },
  [ConfirmSource.PREVIEWED_LINK]: {
    title: l.makeTranslate('Discard this content?'),
    description: l.makeTranslate("This source won't be added to your AI knowledge"),
    confirmButton: l.makeTranslate('Discard'),
    cancelButton: l.makeTranslate('Go back'),
  },
  [ConfirmSource.SCANNING_LINK]: {
    title: l.makeTranslate('Cancel this scan?'),
    description: l.makeTranslate('AI will stop scanning and your progress will be lost'),
    confirmButton: l.makeTranslate('Cancel scan'),
    cancelButton: l.makeTranslate('Continue scanning'),
  },
}

export const getConfirmCopiesBySource = (source: ConfirmSource | null) => {
  if (!source) {
    return copiesBySource.default
  }

  return copiesBySource[source]
}
